import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Feature } from '../../models/product.model';
import { FeatureComponent } from './feature/feature.component';

@Component({
  standalone: true,
  selector: 'base-features',
  templateUrl: './features.component.html',
  styleUrls: ['./features.component.scss'],
  imports: [CommonModule, FeatureComponent]
})
export class FeaturesComponent {

  readonly features = input<Feature[]>([]);

  get uploadedFeatures(): Feature[] {
    return this.features() || [];
  }
}

